// Port of api/fuel/app/classes/insights/players/mostgames.php

import Segment from 'offline/insights/segment'
import Constants from 'offline/constants'
import Util from 'offline/util'

export default Segment.extend({
	name: 'mostgames',
	requires: ['init'],
	types: [Constants.TYPE_USER],
	insight: false,
	detail: ['mostgames'],
	run: function(type, owner, userIndex, detail) {
		var players = Util.sort_by_field_php(this._data.players || [], 'totalGames', false)
		var limit = detail ? 250 : 5
		var total = players.length
		var list = []

		if (players.length > limit) players = players.slice(0, limit)

		for (var i = 0; i < players.length; i++) {
			list.push({
				id: parseInt(players[i].id, 10) || 0,
				slug: players[i].slug,
				name: players[i].primaryName,
				username: players[i].username,
				count: players[i].totalGames,
				plays: players[i].totalPlays
			})
			if (players[i].id) this._references.users.push(parseInt(players[i].id, 10))
		}

		return {
			mostgames: {
				players: list,
				total: total
			}
		}
	}
})
